<template>
  <Modal v-bind="$attrs" v-on="$listeners">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-12">
          <SfHeading :title="$t('Choose Vehicle')" :level="3" class="sf-heading--left" />
        </div>
        <div class="col-xs-12">
          <SfTable class="sf-table--no-border">
            <SfTableHeading>
              <SfTableHeader>{{ $t('Vehicle') }}</SfTableHeader>
            </SfTableHeading>
            <SfTableRow v-for="vehicleData in vehicles" :key="vehicleData.Id" class="vehicle">
              <SfTableData>
                <img :src="carIcon" size="sm" class="car-icon" />
                {{ ' ' }}
                <strong>{{ vehicleData.Vin }} - </strong>
                {{ ' ' }}
                <span>{{ vehicleData.VehicleInfo.marke }} </span>
                <span>{{ vehicleData.VehicleInfo.baureihe }} </span>
                <span>{{ vehicleData.VehicleInfo.verkaufsbezeichnung }} </span>
                <span>{{ vehicleData.VehicleInfo.motor }} </span>
                <span>{{ vehicleData.VehicleInfo.produktionsdatum }} </span>
                <span>{{ $t('Paint') }}: {{ vehicleData.VehicleData.lackCode }} </span>
                <span>{{ $t('Pad') }}: {{ vehicleData.VehicleData.polsterCode }} </span>
                <SfButton
                  class="sf-button--text button-mod"
                  @click="$emit('select', vehicleData)"
                  :aria-label="$t('Select')"
                >
                  {{ $t('Select') }}
                </SfButton>
              </SfTableData>
            </SfTableRow>
          </SfTable>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Modal } from '@/modules/core';
import { SfHeading, SfButton, SfTable } from '@storefront-ui/vue';

import carIcon from '../../assets/car.svg';

export default {
  name: 'VinModal',
  components: {
    Modal,
    SfHeading,
    SfButton,
    SfTable,
  },
  props: {
    vehicles: {
      type: Array,
    },
  },
  data() {
    return {
      carIcon,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~@storefront-ui/shared/styles/_helpers';
@import 'src/scss/_breakpoint';

.sf-modal {
  --modal-width: auto;
}

.button-mod {
  text-transform: uppercase;
  color: var(--c-primary);
}

.info-icon {
  position: relative;
  display: inline-block;
  top: 3px;
  margin-right: 5px;
}

.car-icon {
  position: relative;
  display: inline-block;
  top: 3px;
  width: 16px;
}

.mark {
  color: var(--c-primary);
}

strong {
  font-weight: bold;
}

p {
  font-family: var(--font-family-secondary);
  line-height: 1.2;
}
</style>
